var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{ref:"myChart",style:({ height: _vm.boxHeight + 'rem' }),attrs:{"id":"myChart"}})])}
var staticRenderFns = []

export { render, staticRenderFns }